import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { LoadingOverlay } from 'frontend/js/modules/shared/engage/components/loading-overlay';
import { getSessionShop, useSession } from 'frontend/js/modules/infra/session';
import { Logger } from 'frontend/js/modules/infra/observability/logger';
import { getActiveShopId } from '../../auth/selectors';
import styles from './styles.module.scss';
import config from '../../../config';
import { PhoneAgentAuthQuery } from './network/phone-agent-auth-query';
import SimpleHeader from '../headers/simpleHeader';
var PhoneAgent = function () {
    var session = useSession().data;
    var shop = getSessionShop(session);
    var email = (shop === null || shop === void 0 ? void 0 : shop.email) || '';
    var shopId = useSelector(getActiveShopId);
    var phoneAgentAuthQuery = new PhoneAgentAuthQuery();
    var _a = useQuery(phoneAgentAuthQuery.getKey({ shopId: shopId, email: email }), function () { return phoneAgentAuthQuery.request({ shopId: shopId, email: email }); }, {
        enabled: Boolean(shopId && email),
        cacheTime: 0,
        staleTime: 0,
    }), authData = _a.data, isLoading = _a.isLoading;
    var authToken = (authData === null || authData === void 0 ? void 0 : authData.authToken) || '';
    if (process.env.NODE_ENV !== 'production') {
        Logger.log('Phone Agent Dashboard', {
            shopId: shopId,
            shopName: shop === null || shop === void 0 ? void 0 : shop.name,
            shopTimezone: shop === null || shop === void 0 ? void 0 : shop.timezone,
        });
    }
    var params = ['onboarding_skip_ti_squire=true'];
    if (shop === null || shop === void 0 ? void 0 : shop.name) {
        params.push("onboarding_tf_orgName=".concat(encodeURIComponent(shop.name)));
        params.push('onboarding_skip_tf_orgName=true');
    }
    if (shop === null || shop === void 0 ? void 0 : shop.timezone) {
        params.push("onboarding_timezone=".concat(encodeURIComponent(shop.timezone)));
        params.push('onboarding_skipTimezone=true');
    }
    var src = "".concat(config.phoneAgentUrl, "/app/embed?authToken=").concat(authToken, "&email=").concat(encodeURIComponent(email), "&customerId=").concat(shopId).concat(params.length ? "&".concat(params.join('&')) : '');
    if (isLoading) {
        return _jsx(LoadingOverlay, {});
    }
    return (_jsxs("div", { className: "c-wrapper-allow-header", children: [_jsx(SimpleHeader, { heading: _jsx("span", { className: styles['page-header'], children: _jsx("span", { children: "Phone Agent" }) }) }), _jsx("div", { className: styles.container, children: _jsx("iframe", { title: "Phone Agent Dashboard", className: styles.iframe, src: src, allow: "camera; microphone" }) })] }));
};
export default PhoneAgent;
